import i18n from '../i18n'

export class InputWithCharacterLimitRedesign {
  constructor(element) {
    this.input = element.querySelector('input, textarea')
    this.countElement = element.querySelector('.js-input_with_character_limit__count')
    this.srOnlyElement = element.querySelector('.js-input_with_character_limit__sr_only')
    this.maxLength = this.input.maxLength
    this.attachListener()

    this.updateCountContainerText()
  }

  updateCountContainerText() {
    const currentValue = this.input.value
    let currentLength = currentValue.length

    if (currentLength > this.maxLength) {
      this.input.value = currentValue.substring(0, this.maxLength)
      // When using `data-update-from-input` we listen to input events.
      // Sadly setting the value on the input does not retrigger this event.
      this.input.dispatchEvent(new Event('input'))
      currentLength = this.maxLength
    }

    this.srOnlyElement.innerText = i18n.$ngettext(
      '%{total} out of %{max} character',
      '%{total} out of %{max} characters',
      this.maxLength,
      {
        max: this.maxLength,
        total: currentLength
      }
    )
    this.countElement.innerHTML = currentLength
  }

  attachListener() {
    up.on(
      this.input,
      'input change keyup paste',
      function () {
        this.updateCountContainerText()
      }.bind(this)
    )
  }
}

up.compiler('.js-input_with_character_limit', function (element) {
  new InputWithCharacterLimitRedesign(element)
})
